import React, { useEffect, useState } from "react";
import { ROUTES } from "~/constants";
import { fetchProductExchange, fetchRefundCalculate, fetchSimilarProducts } from "~/services";
import styles from "./return.module.scss";
// import ReturnModal from "./components/ReturnModal";
import ProductItem from "~/components/productItem/ProductItem";
import stylesProductItem from "~/components/productItem/ProductItem.module.scss";
import classnames from "classnames";
import { findSelectedProductValues, removeSelectedProductValues, selectedProductValuesToProduct } from "~/cores/appCore";
import RefundCalculation from "~/components/refundCalculation/RefundCalculation";
import { getOrderStatusUrl } from "~/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import getServerSideProps from "~/app/getServerSideProps";
import { isShipmentMethodPageEnabled } from "~/cores/shipment.core";
import { HeaderTitle } from "~/components/headerComponent/HeaderComponent";
import ReturnIcon from "~/icons/ReturnIcon";
import { Button } from "~/components/buttons/Buttons";
import ProductsFlexWrapper, { ProductFlexItemWrapper } from "~/components/productItem/ProductsFlexWrapper";
import { humanReadableDateTime, useServiceHook } from "rylak-common";
import { faCartArrowDown } from "@fortawesome/pro-regular-svg-icons";

const MAX_INITIAL_RESALES = 5;

function ProductRow(props) {
    const { appProps, product, brandData, brandName, setSelectedProductsValues, setShowModal, sessionId, onProductExchangeUpdated, onSimilarProductsUpdated, foreignOrderId, email, getLocaleText } =
        props;
    const selectedProductValues = findSelectedProductValues(appProps, product.sessionItemId);

    const { serviceData: productExchangeServiceData } = useServiceHook({
        appProps,
        fetchFn: fetchProductExchange,
        fetchRequested: !!product.sessionItemId,
        fetchData: {
            sessionId: sessionId,
            productId: product.sessionItemId,
        },
    });

    const { serviceData: similarProductServiceData } = useServiceHook({
        appProps,
        fetchFn: fetchSimilarProducts,
        fetchRequested: !!product.sessionItemId,
        fetchData: {
            sessionId: sessionId,
            productId: product.actualProductId,
            purchasePrice: product?.purchasePrice,
        },
    });

    useEffect(() => {
        onProductExchangeUpdated({
            productExchangeServiceData,
            productId: product.sessionItemId,
        });
    }, [productExchangeServiceData]);

    useEffect(() => {
        onSimilarProductsUpdated({
            similarProductServiceData,
            productId: product.sessionItemId,
        });
    }, [similarProductServiceData]);

    const returnId = product?.returnId;
    return (
        <div style={{ position: "relative" }}>
            <ProductItem
                onClose={
                    selectedProductValues &&
                    (() => {
                        setSelectedProductsValues(removeSelectedProductValues(appProps, product.sessionItemId));
                    })
                }
                contentOpacity={!!returnId}
                onClick={() => {
                    if (returnId) {
                        window.open(
                            getOrderStatusUrl({
                                brandName,
                                foreignOrderId: foreignOrderId,
                                email: email,
                                returnId: returnId,
                            }),
                        );
                    } else {
                        setShowModal(product.sessionItemId);
                    }
                }}
                {...props}
                product={product}
                selectedProductValues={selectedProductValues}
                subTitle={
                    !!returnId && (
                        <div
                            style={{
                                display: "flex",
                                color: brandData.colorPrimary,
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <div
                                className={stylesProductItem["text-underline"]}
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }}
                            >
                                {getLocaleText("view-return-status")} {humanReadableDateTime({ dateTime: product?.returnDate, shortVersion: false })}
                            </div>
                            <FontAwesomeIcon style={{ width: "14px", marginLeft: "10px" }} icon={faArrowUpRightFromSquare} />
                        </div>
                    )
                }
                className={classnames(returnId && styles["product-item-already-returned"])}
            >
                {/*{!!returnId && <div style={{color: brandData.colorPrimary, position: "absolute", top:5, right:5}}><FontAwesomeIcon style={{width: "16px"}}  icon={faArrowUpRightFromSquare}/></div>}*/}
            </ProductItem>
        </div>
    );
}

function AllOrdersReturnPage(props) {
    let { appProps, system, navigate, loginServiceData, selectedProductsValues, sessionId, addAlert } = props;

    const [, setShowModal] = useState(false);
    const [, setLatestModalProductId] = useState(null);
    const [showAllResales, setShowAllResales] = useState(false);

    const getLocaleText = system.getLocaleText;

    const handleContinueClick = async () => {
        if (selectedProductsValues.length === 0) {
            addAlert({
                content: getLocaleText("return-items.next-back.error_text"),
            });
        } else {
            navigate(
                {
                    pathname: isShipmentMethodPageEnabled(appProps) ? ROUTES.SHIPMENT_METHOD_PAGE.pathname : ROUTES.CONFIRMATION_PAGE.pathname,
                },
                undefined,
                { shallow: true },
            );
        }
    };

    const selectedProductsValuesReturns = selectedProductsValues?.filter((pv) => !selectedProductValuesToProduct(appProps, pv).resaleActive);
    const selectedProductsValuesResales = selectedProductsValues?.filter((pv) => selectedProductValuesToProduct(appProps, pv).resaleActive);

    const { serviceData: refundCalculateServiceDataReturns, fetchServiceData: fetchRefundCalculateReturnsFn } = useServiceHook({
        appProps,
        fetchRequested: false,
        fetchFn: fetchRefundCalculate,
        fetchData: {
            sessionId,
            selectedProductsValues: selectedProductsValuesReturns,
            loginServiceData,
        },
    });

    const { serviceData: refundCalculateServiceDataResales, fetchServiceData: fetchRefundCalculateResalesFn } = useServiceHook({
        appProps,
        fetchRequested: false,
        fetchFn: fetchRefundCalculate,
        fetchData: {
            sessionId,
            selectedProductsValues: selectedProductsValuesResales,
            loginServiceData,
        },
    });

    useEffect(() => {
        if (selectedProductsValues?.length > 0) {
            fetchRefundCalculateResalesFn();
            fetchRefundCalculateReturnsFn();
        }
    }, [selectedProductsValues]);

    const returnProducts = loginServiceData.data.orders.filter((o) => !o.resaleActive).flatMap((o) => o.products);
    const resaleProducts = loginServiceData.data.orders.filter((o) => o.resaleActive).flatMap((o) => o.products);

    const headStyle = {
        // backgroundColor: "black",
        fontSize: "24px",
        width: "fitContent",
        color: "black",
        borderRadius: "5px",
        // padding: "5px 20px"
    };

    return (
        <div>
            {loginServiceData.data && (
                <div>
                    {returnProducts?.length > 0 && (
                        <div style={{ marginBottom: "20px" }}>
                            <HeaderTitle
                                headStyle={headStyle}
                                heading={
                                    <span>
                                        Return items <ReturnIcon width={"32px"} fill={"black"} style={{ marginLeft: "10px" }} />
                                    </span>
                                }
                                body={"These are the items that are still available for you to return or exchange"}
                            />

                            <div style={{ marginTop: "20px" }}>
                                <ProductsFlexWrapper
                                    productsComponents={returnProducts.map((product) => {
                                        return (
                                            <ProductFlexItemWrapper key={product.productVariantId}>
                                                <ProductRow
                                                    {...props}
                                                    setShowModal={(productId) => {
                                                        setLatestModalProductId(productId);
                                                        setShowModal(true);
                                                    }}
                                                    product={product}
                                                />
                                            </ProductFlexItemWrapper>
                                        );
                                    })}
                                >
                                    <ProductFlexItemWrapper newRow={true}>
                                        <RefundCalculation
                                            {...props}
                                            selectedProductsValues={selectedProductsValuesReturns}
                                            totalPriceHeader={getLocaleText("receipt-total-amount")}
                                            collapsible={true}
                                            hidden={selectedProductsValuesReturns.length === 0}
                                            refundCalculateServiceData={refundCalculateServiceDataReturns}
                                        />
                                    </ProductFlexItemWrapper>
                                </ProductsFlexWrapper>
                            </div>
                        </div>
                    )}
                    {resaleProducts?.length > 0 && (
                        <>
                            <HeaderTitle
                                headStyle={headStyle}
                                heading={
                                    <span>
                                        Resale items
                                        <FontAwesomeIcon style={{ marginLeft: "10px" }} width={"30px"} icon={faCartArrowDown} />
                                    </span>
                                }
                                body={"The deadline to return these items has unfortunately passed. However you can still try to put them up for resale!"}
                            />
                            <div style={{ marginTop: "20px" }}>
                                <ProductsFlexWrapper
                                    productsComponents={(showAllResales ? resaleProducts : resaleProducts.slice(0, MAX_INITIAL_RESALES)).map((product) => {
                                        return (
                                            <ProductFlexItemWrapper key={product.productVariantId}>
                                                <ProductRow
                                                    {...props}
                                                    setShowModal={(productId) => {
                                                        setLatestModalProductId(productId);
                                                        setShowModal(true);
                                                    }}
                                                    product={product}
                                                />
                                            </ProductFlexItemWrapper>
                                        );
                                    })}
                                >
                                    {!showAllResales && resaleProducts.length > MAX_INITIAL_RESALES && (
                                        <ProductFlexItemWrapper>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                }}
                                            >
                                                <Button brandColors={true} text={"Show All Products"} onClick={() => setShowAllResales(true)}></Button>
                                            </div>
                                        </ProductFlexItemWrapper>
                                    )}
                                    <ProductFlexItemWrapper newRow={true}>
                                        <RefundCalculation
                                            {...props}
                                            selectedProductsValues={selectedProductsValuesResales}
                                            totalPriceHeader={getLocaleText("receipt-estimated-resale")}
                                            collapsible={true}
                                            hidden={selectedProductsValuesResales.length === 0}
                                            refundCalculateServiceData={refundCalculateServiceDataResales}
                                        />
                                    </ProductFlexItemWrapper>
                                </ProductsFlexWrapper>
                            </div>
                        </>
                    )}

                    {/*<ReturnModal*/}
                    {/*    {...props}*/}
                    {/*    appProps={appProps}*/}
                    {/*    showModal={showModal}*/}
                    {/*    product={products.find((p) => p.sessionItemId === latestModalProductId)}*/}
                    {/*    onModalClose={() => setShowModal(false)}*/}
                    {/*    productExchangeServiceData={productsExchangeServiceData[latestModalProductId]}*/}
                    {/*    similarProductServiceData={similarProductsServiceData[latestModalProductId]}*/}
                    {/*    selectedProductValues={findSelectedProductValues(appProps, latestModalProductId)}*/}
                    {/*    onSave={(data) => {*/}
                    {/*        setSelectedProductsValues(updateSelectedProductValues(appProps, latestModalProductId, data));*/}
                    {/*        setShowModal(false);*/}
                    {/*    }}*/}
                    {/*/>*/}
                    <Button fullWidth={true} text={getLocaleText("continue")} style={{ marginTop: "15px" }} validInput={selectedProductsValues.length > 0} onClick={handleContinueClick} />
                    {/*<StickFooterContinue*/}
                    {/*    {...props}*/}
                    {/*    desktopButtonStyle={{*/}
                    {/*        right: desktopButtonRight,*/}
                    {/*        bottom: 50,*/}
                    {/*    }}*/}
                    {/*    alwaysSticky={true}*/}
                    {/*    style={{ marginTop: "20px", marginLeft: "auto" }}*/}
                    {/*    onClick={handleContinueClick}*/}
                    {/*    buttonRight={true}*/}
                    {/*    validInput={selectedProductsValues.length > 0}*/}
                    {/*/>*/}
                </div>
            )}
        </div>
    );
}

export { getServerSideProps };
export default AllOrdersReturnPage;
